import styled from "@emotion/styled";
import { PRIMARY_BLACK } from "src/constants/colors";

export const SectionContainer = styled.div`
  border-radius: 16px;
  padding: 18px;
  margin-bottom: 24px;
`;

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
  gap: 10px;
`;

export const SectionTitle = styled.h3`
  font-size: 14px;
  font-weight: 500;
  color: ${PRIMARY_BLACK};
  margin: 0;
`;

export const SectionList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
`;
